module.exports = __webpack_public_path__ + "img/casino.d787e084.webp";